export default {
  bagFees:
    'La franchigia in eccesso potrebbe essere soggetta a costi aggiuntivi',
}
